<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="isPending" />
    <template v-else-if="appointment">
      <!-- PROFILE -->
      <Profile :user="appointment.user" :chat="appointment.chat" />

      <!-- BOLETO PAYMENT -->
      <BoletoPayment v-if="appointment.is_waiting_boleto_payment" />

      <!-- PAYMENT ERROR -->
      <PaymentError v-if="appointment.paymentError" />

      <!-- RESCHEDULE REQUEST -->
      <RescheduleRequest
        v-if="appointment.rescheduleRequest"
        :request="appointment.rescheduleRequest"
      />

      <!-- INFO -->
      <Info :item="appointment" />

      <!-- RATING -->
      <Rating :rating="myRating" v-if="myRating" />

      <!-- RECURRENCY -->
      <Recurrency
        :recurrency="appointment.recurrency"
        v-if="appointment.recurrency"
      />

      <!-- VALUES -->
      <Values :item="appointment" />

      <!-- APPOINTMENT RECEIPT -->
      <Receipt v-if="appointment.status === 'concluido'" :item="appointment" />

      <!-- CALL LINK -->
      <CallLink
        v-if="appointment.call_link"
        :callLink="appointment.call_link"
      />

      <!-- RECOMMENDATIONS -->
      <Recommendations />

      <!-- APPOINTMENT CANCELLATION -->
      <Cancellation :item="appointment" />
    </template>
  </div>

  <!-- ACTIONS -->
  <div
    class="offcanvas-footer"
    v-if="
      !isPending &&
      appointment &&
      appointment.status !== 'cancelado' &&
      appointment.status !== 'concluido' &&
      appointment.status !== 'recusado'
    "
  >
    <Actions :item="appointment" />
  </div>
</template>

<script setup lang="ts">
import { useAppointmentDetail } from "@/composables/useAppointments";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { useSessionStore } from "@/store/useSessionStore";
import { computed } from "vue";
import Actions from "./Actions.vue";
import BoletoPayment from "./BoletoPayment.vue";
import CallLink from "./CallLink.vue";
import Cancellation from "./Cancellation.vue";
import Info from "./Info.vue";
import PaymentError from "./PaymentError.vue";
import Profile from "./Profile.vue";
import Rating from "./Rating.vue";
import Receipt from "./Receipt.vue";
import Recommendations from "./Recommendations.vue";
import Recurrency from "./Recurrency.vue";
import RescheduleRequest from "./RescheduleRequest.vue";
import Values from "./Values.vue";

const offcanvasStore = useOffcanvasStore();
const sessionStore = useSessionStore();
const detailId = computed(
  () => offcanvasStore.config?.detail_id as number | undefined,
);

const { data: appointment, isPending } = useAppointmentDetail(detailId);

const myRating = computed(() => {
  const appt = appointment.value;
  if (!appt || appt.status !== "concluido" || !appt.ratings?.length)
    return null;
  const sessionId = sessionStore.session?.id;
  const found = appt.ratings.find((r) => r.user_id === sessionId);
  return found?.rating != null ? found : null;
});
</script>
